import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import HistoryMovementsViewExpandedTableHeader from './HistoryMovementsViewExpandedTableHeader';
import HistoryMovementsViewExpandedTableBody from './HistoryMovementsViewExpandedTableBody';

import { useHistoryMovementsView } from '../context/HistoryMovementsViewContext';

const HistoryMovementsViewExpandedTable: FC = () => {
  const { data, actions } = useHistoryMovementsView();
  return (
    <>
      <table className="table" id="expanded-table">
        <HistoryMovementsViewExpandedTableHeader />
        <HistoryMovementsViewExpandedTableBody />
      </table>

      <TablePagination
        totalRows={data.totalHistoryMovements}
        defaultRowsPerPage={data.rowsPerPage}
        onChangePage={actions.handleChangePage}
        onChangeRowsPerPage={actions.handleChangeRowsPerPage}
      />
    </>
  );
};

export default HistoryMovementsViewExpandedTable;
